import { create } from 'zustand';

interface AuthUser {
  id: number;
  email: string;
  full_name: string | null;
  tier: string;
}

interface AuthState {
  token: string | null;
  user: AuthUser | null;
  setToken: (token: string) => void;
  logout: () => void;
  fetchMe: () => Promise<void>;
}

const TOKEN_KEY = 'dnsscience_token';

export const useAuthStore = create<AuthState>((set, get) => ({
  token: localStorage.getItem(TOKEN_KEY),
  user: null,

  setToken(token: string) {
    localStorage.setItem(TOKEN_KEY, token);
    set({ token });
  },

  logout() {
    localStorage.removeItem(TOKEN_KEY);
    set({ token: null, user: null });
  },

  async fetchMe() {
    const { token } = get();
    if (!token) return;
    try {
      const res = await fetch('/api/auth/me', {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.status === 401) {
        // Token expired or invalid — clear it
        localStorage.removeItem(TOKEN_KEY);
        set({ token: null, user: null });
        return;
      }
      if (res.ok) {
        const data = await res.json();
        set({ user: data });
      }
    } catch {
      // Network error — keep token, don't log out
    }
  },
}));
